import { DateRangeType } from '@/interfaces/common.interfaces';

import isIsoDate from './isIsoDate';

function instanceOfDateRange(object: any): object is DateRangeType {
  return Array.isArray(object) && object.length === 2 && object.every(n => isIsoDate(n));
}

export default instanceOfDateRange;
